export default __webpack_public_path__ + "static/media/Car_Lora_Thumb_VW_Tiguan.43bd48d0.jpg";